export default (key) => {
    let src
    try {
        src = require(`flag-icon-css/flags/4x3/${key.toLowerCase().substring(0, 2)}.svg`)
    } catch (error) {
        src = ''
    }
    return src
}